import React from "react";
import { Button, Flex, Text } from "@radix-ui/themes";
import { SessionNotification as SessionNotificationType } from "../entities/SessionNotification";
import { MessageText } from "./message/MessageText";
import { QuackWidgetCard } from "./QuackWidgetCard";
import { ChatSettingsV2 } from "../entities/ChatSettingsV2";

interface SessionNotificationProps {
  settings: ChatSettingsV2;
  notification: SessionNotificationType;
  onAcknowledge: () => void;
}

export function SessionNotification({
  settings,
  notification: { title, message, ctaLabel },
  onAcknowledge,
}: SessionNotificationProps) {
  return (
    <Flex direction={"column"} className={"qc-Chat__SessionNotification"} justify="end">
      <QuackWidgetCard settings={settings}>
        <Flex
          pt={"6"}
          pb={"4"}
          px={"5"}
          direction={"column"}
          gap={"3"}
          className={"qc-Chat__SessionNotification__Content"}
        >
          <Text size={"2"} color={"gray"} weight={"medium"} highContrast>
            {title}
          </Text>

          <MessageText text={message} />

          <Flex justify="end">
            <Button
              color="gray"
              variant="solid"
              onClick={onAcknowledge}
              className="qc-Chat__CTAButton"
              aria-label={ctaLabel}
            >
              {ctaLabel}
            </Button>
          </Flex>
        </Flex>
      </QuackWidgetCard>
    </Flex>
  );
}
